export const structureLayoutUploadContent = {
  title: 'Structure Layout Image Upload',
  description:
    'Take a photo, or upload an existing one, of your floor plan. It can be an image, PDF, or a hand-drawn sketch.',
  fileInputId: 'layout-image',
  acceptedFileTypes: 'image/*,application/pdf',
  uploadButtonText: 'Upload Image(s)',
  uploadResultsTitle: 'Uploaded Images',
  examples: [
    {
      id: 'layout-sketch',
      url: 'structure/sketch-example.jpg',
      name: 'Layout Sketch Example'
    },
    {
      id: 'floorplan',
      url: 'structure/floorplan-example.jpg',
      name: 'Floor Plan Example'
    }
  ],
  featureImage: {
    id: 'ai-assisted-photo',
    url: 'structure/ai-example.png',
    name: 'Take a picture with your phone or upload an existing file'
  }
} as const;

export const existingEquipmentUploadContent = {
  title: 'Existing Equipment Photo Upload',
  description:
    'Take a clear photo of the data or rating label on your existing HVAC equipment. The label usually shows the model number and electrical details.',
  fileInputId: 'existing-equipment-image',
  acceptedFileTypes: 'image/*',
  uploadButtonText: 'Upload Equipment Photo(s)',
  uploadResultsTitle: 'Uploaded Equipment Photos',
  examples: [
    {
      id: 'indoor-equipment-label',
      url: 'equipment/indoor-label-example.png',
      name: 'Indoor Equipment Label Example'
    }
  ],
  featureImage: {
    id: 'outdoor-equipment-label',
    url: 'equipment/outdoor-label-example.png',
    name: 'Outdoor Equipment Label Example'
  }
} as const;
